import React, { useMemo } from 'react'
import { DeleteButton, SaveButton, Toolbar, useRecordContext } from 'react-admin'
import { Stack } from '@mui/material'
import { FormBottomToolbarWithPermissionProps } from './type'
import { BackButton, SaveWithConfirmButton } from '../buttons'

const FormBottomToolbarWithPermission: React.FC<FormBottomToolbarWithPermissionProps> = ({
  children,
  hasConfirm = false,
  isCreate = false,
  leftButtons,
  rightButtons,
  encType,
  showDeleteButton = true,
  transform,
  label,
}) => {
  const confirmProps = useMemo(
    () => ({
      confirmTitle: isCreate ? 'ra.message.bulk_create_title' : 'ra.message.bulk_update_title',
      confirmContent: isCreate
        ? 'ra.message.bulk_create_content'
        : 'ra.message.bulk_update_content',
    }),
    [isCreate],
  )

  const record = useRecordContext()

  const DeleteButtonComponent = (): JSX.Element => {
    if (showDeleteButton) {
      return (
        <Stack direction='row' gap={2}>
          {record ? <DeleteButton size='medium' confirmTitle='คุณต้องการลบข้อมูลหรือไม่?'/>: <BackButton />}
          {leftButtons}
        </Stack>
      )
    } else {
      return <Stack direction='row' gap={2}></Stack>
    }
  }

  return (
    <Toolbar sx={{ justifyContent: 'space-between', py: 1.5 }}>
      <Stack flexGrow={1} spacing={1}>
        <Stack direction='row' justifyContent='space-between'>
          <DeleteButtonComponent />
          <Stack direction='row' justifyContent='space-between' gap={2}>
            {rightButtons}
            {hasConfirm ? (
              <SaveWithConfirmButton encType={encType} {...confirmProps} transform={transform} />
            ) : (
              <SaveButton size='medium' transform={transform} label={label}/>
            )}
          </Stack>
        </Stack>
        {children}
      </Stack>
    </Toolbar>
  )
}

export default FormBottomToolbarWithPermission
